import Callbacks from 'lib/callbacks.js';

export default class AbstractBlock {
    constructor(opts = {}, events = {}) {
        this.opts = opts;
        this.events = new Callbacks(events);
        this.shown = !!opts.shown;
    }

    get hasElement() {
        return this.element && this.element.length;
    }

    get elementHidden() {
        if (!this.hasElement) {
            return undefined;
        }

        return this.element.hasClass('hidden');
    }

    /**
     * Set shown state to element hidden state
     */
    syncShowState() {
        if (!this.hasElement) {
            return;
        }

        if (this.shown) {
            if (this.elementHidden) {
                this.shown = false;
                this.show();
            }
        } else {
            if (!this.elementHidden) {
                this.shown = true;
                this.hide();
            }
        }
    }

    /**
     * Отобразить блок
     *
     * @return {Boolean} result Успешность операции
     */
    show() {
        if (this.shown || !this.hasElement) {
            return false;
        }

        this.element.removeClass('hidden');
        this.shown = true;
        return true;
    }

    /**
     * Скрыть блок
     *
     * @return {Boolean} result Успешность операции
     */
    hide() {
        if (!this.shown || !this.hasElement) {
            return false;
        }

        this.element.addClass('hidden');
        this.shown = false;
        return true;
    }

    /**
     * Отобразить загрузку элемента
     *
     * @param  {Boolean} value Состояние загрузки
     */
    set loading(value) {
        if (!this.shown || !this.hasElement) {
            return;
        }

        if (value) {
            this.element.addClass('loading');
            return;
        }

        this.element.removeClass('loading');
    }
}
